<template>
  <vx-card ref="filterCard" class="vx-card mb-5" :class="showFilters? 'zoom-fade-enter-to' : 'zoom-fade-leave-to'"
    :title="$t('filters.title')" :collapse-action="horizontal"
    :refresh-content-action="horizontal" @refresh="onResetFilters">
    <vs-row :key="filtersKey">
      <vs-col class="w-full" :class="horizontal ? 'md:w-1/5 sm:w-1/2 px-2' : 'my-2'" v-for="filter in filters" :key="filter.id">
        <sm-hateoas-filter-date-picker v-if="filter.type==='DATE_PICKER'"
                                      :filter="filter"
                                      @change="onFilterChange(filter,$event)"></sm-hateoas-filter-date-picker>
        <sm-hateoas-filter-date-range v-if="filter.type==='DATE_RANGE'"
                                      :filter="filter"
                                      @change="onFilterChange(filter,$event)"></sm-hateoas-filter-date-range>
        <sm-hateoas-filter-terms v-if="filter.type==='TERMS' && !horizontal && filter.terms.length < 10"
                                 :filter="filter"
                                 @change="onFilterChange(filter,$event)"></sm-hateoas-filter-terms>
        <sm-hateoas-filter-terms-select v-else-if="filter.type==='TERMS' && horizontal || filter.type==='TERMS' && filter.terms.length >= 10"
                                 :filter="filter"
                                 @change="onFilterChange(filter,$event)"></sm-hateoas-filter-terms-select>
        <sm-hateoas-filter-sub-terms-select v-else-if="filter.type==='SUB_TERMS'"
                                 :filter="filter"
                                 @change="onFilterChange(filter,$event)"></sm-hateoas-filter-sub-terms-select>
        <sm-hateoas-filter-select v-if="filter.type==='SELECT'"
                                  :filter="filter"
                                  @change="onFilterChange(filter,$event)"></sm-hateoas-filter-select>
        <sm-hateoas-filter-boolean v-if="filter.type ==='BOOLEAN'"
                                   :filter="filter"
                                   @change="onFilterChange(filter,$event)"></sm-hateoas-filter-boolean>
      </vs-col>
    </vs-row>
  </vx-card>
</template>

<script>
/* eslint-disable no-invalid-this */
/* eslint-disable security/detect-object-injection */
/* eslint-disable security/detect-non-literal-regexp */
import _ from 'lodash';
import SmHateoasFilterDateRange from '@/components/starling/sm-hateoas-filters/date-range/sm-hateoas-filter-date-range';
import SmHateoasFilterTerms from '@/components/starling/sm-hateoas-filters/terms/sm-hateoas-filter-terms';
import SmHateoasFilterTermsSelect from '@/components/starling/sm-hateoas-filters/terms/sm-hateoas-filter-terms-select';
import SmHateoasFilterSubTermsSelect from '@/components/starling/sm-hateoas-filters/terms/sm-hateoas-filter-sub-terms-select';
import SmHateoasFilterSelect from '@/components/starling/sm-hateoas-filters/select/sm-hateoas-filter-select';
import {ResourceImpl} from 'hal-client';
import SmHateoasFilterBoolean from '@/components/starling/sm-hateoas-filters/checkbox/sm-hateoas-filter-boolean';
import SmHateoasFilterDatePicker from '@/components/starling/sm-hateoas-filters/date-picker/sm-hateoas-filter-date-picker';

export default {
  name: 'sm-hateoas-filters',
  components: {
    SmHateoasFilterBoolean,
    SmHateoasFilterSelect,
    SmHateoasFilterTerms,
    SmHateoasFilterTermsSelect,
    SmHateoasFilterDateRange,
    SmHateoasFilterDatePicker,
    SmHateoasFilterSubTermsSelect
  },
  props: {
    filterResource: ResourceImpl,
    horizontal: {
      type: Boolean,
      required: false,
      default: false
    },
    visible: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      filtersKey: 0,
      filters: this.filterResource.$getEmbedded('filters'),
      context: {},
      debounceFn: null,
      showFilters: false
    };
  },
  watch: {
    context: {
      deep: true,
      handler (value) {
        this.debounceFn(value);
      }
    },
    filters: {
      handler (value) {
        if (!this.context) return;
        const toRemove = [];
        Object.keys(this.context).forEach(key => {
          if (!value.some(f => f.parameterName === key)) {
            toRemove.push(key);
          }
        });
        toRemove.forEach(key => delete this.context[key]);
      }
    }
  },
  created () {
    const fn = (value) => {
      this.$emit('filters-change', value);
    };
    this.debounceFn = _.debounce(fn, 1000);
    this.showFilters = this.visible;
  },
  methods: {
    onFilterChange (filter, value) {
      this.context = Object.assign({}, this.context);
      this.$set(this.context, filter.parameterName, value);

      if (filter.refresh) {
        this.filterResource.$request().$get('refresh', this.context).then(res => {
          this.filters = res.$getEmbedded('filters');
        });
      }
    },
    onShowFilters () {
      if (this.showFilters) {
        this.showFilters = !this.showFilters;
        setTimeout(() => {
          this.$emit('update-transition');
        }, 300);
      } else {
        //this.showFiltersTransition = !this.showFiltersTransition;
        this.$emit('update-transition');
        setTimeout(() => {
          this.showFilters = !this.showFilters;
        }, 300);
      }
    },
    onResetFilters () {
      this.context = {};
      this.filters = this.filterResource.$getEmbedded('filters');
      this.$refs.filterCard.removeRefreshAnimation();
      this.filtersKey++;
    }
  }
};
</script>

<style scoped>

</style>
